import type { AccountLocale } from "./locales";

const INTERCOM_LANGUAGE_OVERRIDES = {
  en: "en",
  "es-ES": "es",
  "es-419": "es",
  "fr-FR": "fr",
  "fr-CA": "fr",
  ko: "ko",
  "pt-BR": "pt-BR",
  ru: "ru",
  "zh-Hans": "zh-CN",
  "zh-Hant": "zh-TW",
  de: "de",
  nl: "nl",
  sv: "sv",
  cs: "cs",
  no: "nb",
  vi: "vi",
} as const satisfies Record<AccountLocale, string>;

export function getIntercomLanguageOverride(locale: AccountLocale): string {
  return INTERCOM_LANGUAGE_OVERRIDES[locale];
}
